import "./config/fetchOverride";
import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";

import App from "./App";
import ErrorBoundary from "./components/common/ErrorBoundary";
import reportWebVitals from "./reportWebVitals";
import { WishlistProvider } from "./context/WishlistContext";
//import { DarkModeProvider } from "./context/DarkModeContext";
//<DarkModeProvider>

import { HelmetProvider } from "react-helmet-async";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
      <HelmetProvider>
        <ErrorBoundary>
          <WishlistProvider>
            <App />
          </WishlistProvider>
        </ErrorBoundary>
      </HelmetProvider>
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
